import BaseButton from 'app/components/common/BaseButton';
import { buttonReset } from 'app/constants/Styles';
import { useCss, IStyles } from 'app/utils/css';
import React from 'react';

interface IProps extends React.ComponentProps<typeof BaseButton> {
  children: React.ReactNode;
  'aria-label': string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  overrideStyles?: IStyles;
}

/**
 * Icon Button that handles its focus correctly (using BaseButton)
 * and requires an aria label.
 */
const IconButton: React.FunctionComponent<IProps> = ({
  children,
  disabled = false,
  overrideStyles,
  ...rest
}) => {
  const css = useCss();

  return (
    <BaseButton
      {...rest}
      disabled={disabled}
      className={css('iconButton', {
        ...buttonReset,
        position: 'relative',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        ...overrideStyles,
      })}
    >
      {children}
    </BaseButton>
  );
};

export default IconButton;
